import axiosAuth from "@/services/axiosAuth";
import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { DASHBOARD_PM_CLOSURE_READINESS_API } from "./apiRoutes";

interface Props {
  projectId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getClosureReadiness = async (projectId: string) => {
  return await axiosAuth.get(`${DASHBOARD_PM_CLOSURE_READINESS_API(projectId)}`);
};

const useGetPmClosureReadiness = ({ projectId, queryParams }: Props): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["dashboard-closure-readiness", projectId],
    queryFn: () => getClosureReadiness(projectId),
    select: (data: any) => data.data.data,
    refetchOnWindowFocus: false,
    enabled: !!projectId,
    ...queryParams,
  });
};

export default useGetPmClosureReadiness;
